// ¿La unidad tiene dónde dibujarse en el mapa? La misma regla decide qué
// marcadores se pintan (MapView) y qué unidades se pueden seguir: seguir una
// sin posición (p. ej. "Thermo 5312", sin reporte) mostraba "Siguiendo" y
// acercaba a zoom 19 sobre un mapa vacío.
export function hasMapPosition(v: { coordinates?: unknown; latitude?: number | null; longitude?: number | null } | null | undefined): boolean {
  if (!v || !v.coordinates || v.latitude == null || v.longitude == null) return false;
  if (Number.isNaN(v.latitude) || Number.isNaN(v.longitude)) return false;
  return !(v.latitude === 0 && v.longitude === 0);
}
